import dayjs from "dayjs";
import React, { useCallback, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useNavigate } from "react-router-dom";
import { useAddDateOptions } from "../api/date-options";
import { useAddEvent } from "../api/events-api";
import { queryClient } from "../api/queryClient";
import EventForm, { EventFormValues } from "../components/events/EventForm";
import { AdminHeader, Eyebrow } from "../components/dss/Primitives";

const AddEvent: React.FC = () => {
  const { mutateAsync: addEvent } = useAddEvent();
  const { mutateAsync: addDateOptions } = useAddDateOptions();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [voteDates, setVoteDates] = useState<Date[]>([]);

  const onSubmit = useCallback(
    async (formValues: EventFormValues) => {
      try {
        setErrorMessage(null);
        const event = await addEvent(formValues);
        if (voteDates.length > 0) {
          await addDateOptions({
            eventId: event.id,
            selectedDates: voteDates.map((d) => dayjs(d).format("YYYY-MM-DD")),
          });
        }
        queryClient.invalidateQueries();
        navigate("/edit");
      } catch (error) {
        setErrorMessage(error instanceof Error ? error.message : "Ukendt fejl");
      }
    },
    [addDateOptions, addEvent, navigate, voteDates],
  );

  const today = dayjs().format("YYYY-MM-DD");

  return (
    <div className="mx-auto max-w-md bg-paper pt-safe min-h-app">
      <AdminHeader back="Admin" onBack={() => navigate("/edit")} title={<>Ny<br />samling</>} />
      <div className="px-7 pt-5 pb-8">
        {errorMessage && (
          <div className="mb-4 font-mono text-[11px] text-clay uppercase tracking-wide">
            Kunne ikke gemme: {errorMessage}
          </div>
        )}
        <EventForm
          initialValues={{
            status: "draft",
            showVoteLink: true,
            date: today,
            time: "18:00",
          }}
          submitLabel="Indkald samling"
          onSubmit={onSubmit}
        >
          <div>
            <Eyebrow className="mb-2.5">[ Afstemning · foreslå datoer ]</Eyebrow>
            <div className="rounded-lg overflow-hidden border border-line-soft bg-card p-2 flex justify-center">
              <DayPicker
                mode="multiple"
                weekStartsOn={1}
                selected={voteDates}
                onSelect={(dates) => setVoteDates(dates ?? [])}
                className="dss-calendar"
                modifiersClassNames={{ selected: "!bg-ink !text-paper !font-bold" }}
              />
            </div>
          </div>
        </EventForm>
      </div>
    </div>
  );
};

export default AddEvent;
